import React from 'react';
import { useProductCodes } from '../context/ProductCodesContext';

/**
 * PUBLIC product-code badge — shown to EVERYONE (including client-portal
 * users). Use this for client-facing recipe variant IDs (TI-151, TI-151-T2).
 *
 * If the product name does not have a registered Product Code, nothing is
 * rendered (graceful no-op).
 *
 * Usage:
 *   <ProductCodeBadge name={b.product_name} />
 *   <ProductCodeBadge code={b.product_code} />  // use an explicit code
 *
 * Order-independent from CodeLabel (which hides for non-admins). These two
 * can sit together: e.g. `<ProductCodeBadge /> <CodeLabel />` renders
 * "TI-151-T2 · L 100 · Palm Oil" for admins, "TI-151-T2 · Palm Oil" for
 * everyone else.
 */
export default function ProductCodeBadge({ name, code: explicitCode, className = '' }) {
  const { lookupProduct } = useProductCodes();
  const code = explicitCode || lookupProduct(name);
  if (!code) return null;
  return (
    <span
      data-testid="product-code-badge"
      className={`inline-flex items-center px-1.5 py-0.5 rounded bg-sky-500/15 text-sky-300 border border-sky-600/30 font-mono text-[10px] font-bold tracking-wide whitespace-nowrap ${className}`}
      title={`Product Code: ${code}`}
    >
      {code}
    </span>
  );
}
